/**
 * BOTTOM GENERAL INITS
 * "PAGE"
 */

import { PageViews } from "./pageViews";
import { PageViewsTracking } from "./pageViewsTracking";


export class PageInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new PageViews();
        new PageViewsTracking();
    }
}
